import { createActionsHook } from 'src/lib/sweetState';

import { MainStore } from './MainStore';

export const useMainActions = createActionsHook(MainStore);
